module.exports = __webpack_public_path__ + "img/boneless-lean-stew.b7c54eb8.jpg";